import React, { useMemo, useState } from "react";
import AbsentReason from "./MasterSetting/AbsentReason/AbsentReason";
import BatchTime from "./MasterSetting/BatchTime/BatchTime";
import Country from "./MasterSetting/Country/Country";
import IDType from "./MasterSetting/IdType/IDType";
import Race from "./MasterSetting/Race/Race";
import Tax from "./MasterSetting/Tax/Tax";

const MasterSettings = () => {
  /* -------------------- ROLE MATRIX -------------------- */
  const storedScreens = JSON.parse(localStorage.getItem("screens") || "{}");

  const canAbsentReason = Boolean(storedScreens?.absentReasonSettingIndex);
  const canBatchTime = Boolean(storedScreens?.batchtimeSettingIndex);
  const canCountry = Boolean(storedScreens?.countrySettingIndex);
  const canIdType = Boolean(storedScreens?.idTypeSettingIndex);
  const canRace = Boolean(storedScreens?.raceSettingIndex);
  const canTax = Boolean(storedScreens?.taxSettingIndex);

  const tabs = useMemo(() => {
    const list = [];
    if (canTax) list.push({ id: "tax", label: "Tax" });
    if (canRace) list.push({ id: "race", label: "Race" });
    if (canCountry) list.push({ id: "country", label: "Country" });
    if (canAbsentReason)
      list.push({ id: "absentReason", label: "Absent Reason" });
    if (canBatchTime) list.push({ id: "batchTime", label: "Class Timeslot" });
    if (canIdType) list.push({ id: "idType", label: "ID Type" });
    return list;
  }, [canAbsentReason, canBatchTime, canCountry, canIdType, canRace, canTax]);

  const [activeTab, setActiveTab] = useState(tabs[0]?.id);
  if (!tabs.length) return null;

  return (
    <div className="p-1">
      {/* TAB HEADER */}
      <div className="container-fluid p-0 my-2">
        <div className="card shadow-sm border-0 p-2">
          <div className="d-flex gap-3 px-2 overflow-auto">
            {tabs.map((tab, index) => (
              <React.Fragment key={tab.id}>
                <button
                  className={`btn btn-sm fw-semibold tab-btn ${
                    activeTab === tab.id ? "active-tab-btn" : "inactive-tab-btn"
                  }`}
                  style={{
                    border: activeTab === tab.id ? "none" : "1px solid #ddd",
                    whiteSpace: "nowrap",
                  }}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {tab.label.toUpperCase()}
                </button>

                {index < tabs.length - 1 && (
                  <span style={{ color: "#e5e5e5" }}>|</span>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      {/* TAB CONTENT */}
      <div className="container">
        <div className="card shadow-sm mt-3 p-3">
          {activeTab === "absentReason" && canAbsentReason && <AbsentReason />}
          {activeTab === "batchTime" && canBatchTime && <BatchTime />}
          {activeTab === "country" && canCountry && <Country />}
          {activeTab === "idType" && canIdType && <IDType />}
          {activeTab === "race" && canRace && <Race />}
          {activeTab === "tax" && canTax && <Tax />}
        </div>
      </div>
    </div>
  );
};

export default MasterSettings;
